import { Transfer } from "./transfer";
import { Link } from "@nextui-org/link";
import { siteConfig } from "@/config/site";
import { button as buttonStyles } from "@nextui-org/theme";
import { Icon } from "@iconify/react";
import { title, subtitle } from "@/components/primitives";

export const Hero = () => {
  return (
    <div className="flex ct-hero w-full ct-section justify-center md:mx-auto">
      <div className="md:container xl:columns-2 lg:columns-2 gap-4 mt-[80px]">
        <div className="lg:w-full xl:1/2 md:w-full sm:w-full ct-description p-3 sm:p-2 text-center mb-8 w-full">
          <h1
            data-aos="fade-in"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
            className={title()}>
            <span className={title({ color: "violet", size: "lg" })}>
              Crypto
            </span>{" "}
            to cash in transit.
          </h1>
          <p
            data-aos="fade-up"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
            className={subtitle({ class: "mt-7" })}>
            Our platform empowers you to send cryptocurrencies such as USDT,
            USDC directly into bank accounts worldwide, converting it instantly
            into local currencies. Whether you're paying for services,
            purchasing goods, or conducting business transactions, CryptoTX
            ensures your funds move effortlessly across borders.
          </p>
          <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col justify-center mt-8 break-after-column gap-6">
            <Link
              isExternal
              className={buttonStyles({variant: "shadow", radius: "md", size: "lg", color: "primary" })}
              data-aos="slide-up"
              href={siteConfig.links.login}>
              Login {<Icon icon="mdi:login" />}
            </Link>
            <Link
              isExternal
              data-aos="slide-up"
              className={buttonStyles({variant: "shadow", radius: "md", size: "lg", color: "primary" })}
              href={siteConfig.links.register}>
              Register an account {<Icon icon="mdi:register-outline" />}
            </Link>
          </div>
        </div>
        <div className="lg:w-full xl:w-5/6 md:w-full sm:w-full ct-transfer flex flex-wrap items-center flex-col justify-center">
          <Transfer />
        </div>
      </div>
    </div>
  );
};
